import React, { useState, useEffect } from 'react';
import { useClient } from '../../context/ClientContext';

const TYPE_COLORS = {
  'Search': '#2563eb',
  'Performance Max': '#7c3aed',
  'Shopping': '#f59e0b',
  'Display': '#06b6d4',
  'Video': '#ef4444',
  'Demand Gen': '#ec4899'
};

export default function CampaignTypeBreakdown({ dateRange }) {
  const { brand, fetcher } = useClient();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetcher.fetchCampaignTypeBreakdown(dateRange)
      .then(setData)
      .finally(() => setLoading(false));
  }, [dateRange]);

  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-1/3 mb-4"></div>
        <div className="space-y-3">
          {[...Array(3)].map((_, i) => <div key={i} className="h-12 bg-gray-200 rounded"></div>)}
        </div>
      </div>
    );
  }

  if (!data?.types?.length) return null;

  const totalCost = data.types.reduce((s, t) => s + t.cost, 0);
  const currency = data.currency || '$';

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100 p-6">
      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-1"
          style={{ fontFamily: brand.typography?.headerFont }}>
        Campaign Types
      </h3>
      <p className="text-xs text-gray-400 mb-4">Spend & performance by campaign type</p>

      <div className="space-y-3">
        {data.types.map((t) => {
          const pct = totalCost > 0 ? (t.cost / totalCost) * 100 : 0;
          const color = TYPE_COLORS[t.type] || (brand.colors?.primary || '#2563eb');

          return (
            <div key={t.type} className="space-y-1.5">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-gray-900">{t.type}</span>
                <span className="text-xs text-gray-500">{pct.toFixed(0)}% of spend</span>
              </div>

              <div className="w-full bg-gray-100 rounded-full h-2">
                <div
                  className="h-2 rounded-full transition-all duration-500"
                  style={{ width: `${pct}%`, backgroundColor: color }}
                />
              </div>

              <div className="flex gap-4 text-xs text-gray-500">
                <span>{t.conversions} conv.</span>
                <span>{currency}{t.cost.toFixed(0)} spend</span>
                {t.conversions > 0 && <span>{currency}{t.cpa.toFixed(0)} CPA</span>}
                <span>{t.convRate.toFixed(1)}% conv. rate</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
